import * as React from "react"

import { cn } from "../../lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-12 w-full rounded-[8px] border border-input bg-white px-3 text-vt-texte font-medium text-foreground placeholder:text-t2 focus-visible:border-brand focus-visible:outline-none disabled:cursor-not-allowed",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
